$(document).ready(function() {
		/*!
	* jquery.instagramFeed
	*
	* @version 1.2.0
	*
	* @author Javier Sanahuja Liebana <bannss1@gmail.com>
	* @contributor csanahuja <csanahuja@gmail.com>
	*
	* https://github.com/jsanahuja/jquery.instagramFeed
	*
 */
	(function(h){var k={host:"https://www.instagram.com/",username:"",tag:"",container:"",display_profile:!0,display_biography:!0,display_gallery:!0,display_igtv:!1,get_data:!1,callback:null,styling:!0,items:8,items_per_row:4,margin:.5,image_size:640},l={150:0,240:1,320:2,480:3,640:4};h.instagramFeed=function(r){var a=h.fn.extend({},k,r);if(""==a.username&&""==a.tag)return console.error("Instagram Feed: Error, no username or tag found."),!1;"undefined"!==typeof a.get_raw_json&&(console.warn("Instagram Feed: get_raw_json is deprecated. See use get_data instead"),a.get_data=a.get_raw_json);if(!a.get_data&&""==a.container)return console.error("Instagram Feed: Error, no container found."),!1;if(a.get_data&&null==a.callback)return console.error("Instagram Feed: Error, no callback defined to get the raw json"),!1;var m=""==a.username;h.get(m?a.host+"explore/tags/"+a.tag:a.host+a.username,function(b){b=b.split("window._sharedData = ")[1].split("\x3c/script>")[0];b=JSON.parse(b.substr(0,b.length-1));b=b.entry_data.ProfilePage||b.entry_data.TagPage;b=b[0].graphql.user||b[0].graphql.hashtag;if(a.get_data)a.callback(b);else{var d="",f="",g="",e="",n="";a.styling&&(d=" style='text-align:center;'",f=" style='border-radius:10em;width:15%;max-width:125px;min-width:50px;'",g=" style='font-size:1.2em;'",e=" style='font-size:1em;'",n=" style='margin:"+a.margin+"% "+a.margin+"%;width:"+(100-2*a.margin*a.items_per_row)/a.items_per_row+"%;float:left;'");var c="";a.display_profile&&(c=c+("<div class='instagram_profile'"+d+">")+("\t<img class='instagram_profile_image' src='"+b.profile_pic_url+"' alt='"+b.name+" profile pic'"+f+" />"),c=m?c+("\t<p class='instagram_tag'"+g+"><a href='https://www.instagram.com/explore/tags/"+a.tag+"' rel='noopener' target='_blank'>#"+a.tag+"</a></p>"):c+("\t<p class='instagram_username'"+g+">@"+b.full_name+" (<a href='https://www.instagram.com/"+a.username+"' rel='noopener' target='_blank'>@"+a.username+"</a>)</p>"),!m&&a.display_biography&&(c+="\t<p class='instagram_biography'"+e+">"+b.biography+"</p>"),c+="</div>");g="undefined"!==typeof l[a.image_size]?l[a.image_size]:l[640];if(a.display_gallery)if("undefined"!==typeof b.is_private&&!0===b.is_private)c+="<p class='instagram_private'><strong>This profile is private</strong></p>";else{e=(b.edge_owner_to_timeline_media||b.edge_hashtag_to_media).edges;f=e.length>a.items?a.items:e.length;c+="<div class='instagram_gallery'>";for(d=0;d<f;d++){var k="https://www.instagram.com/p/"+e[d].node.shortcode;switch(e[d].node.__typename){case "GraphSidecar":var p="sidecar";var q=e[d].node.thumbnail_resources[g].src;break;case "GraphVideo":p="video";q=e[d].node.thumbnail_src;break;default:p="image",q=e[d].node.thumbnail_resources[g].src}c+="\t<a href='"+k+"' class='instagram-"+p+"' rel='noopener' target='_blank'>";c+="   \t<img src='"+q+"' alt='"+b.name+" instagram image "+d+"'"+n+" />";c+="\t</a>"}c+="</div>"}if(a.display_igtv&&"undefined"!==typeof b.edge_felix_video_timeline&&(b=b.edge_felix_video_timeline.edges,f=b.length>a.items?a.items:b.length,0<b.length)){c+="<div class='instagram_igtv'>";for(d=0;d<f;d++)c+="\t<a href='https://www.instagram.com/p/"+b[d].node.shortcode+"' rel='noopener' target='_blank'>",c+="\t\t<img src='"+b[d].node.thumbnail_src+"' alt='"+a.username+" instagram image "+d+"'"+n+" />",c+="\t</a>";c+="</div>"}h(a.container).html(c)}}).fail(function(a){console.error("Instagram Feed: Unable to fetch the given user/tag. Instagram responded with the status code: ",a.status)});return!0}})(jQuery);

	function BlogSearch() {
		_this = this;
		var domain = "https://airflyby.com/";
		// var domain = "http://127.0.0.1/";
		var apikey = "cfdb477eff91f83025e90c86a7";
		// var apikey = "a1872ece084dead4877baa78bc";
		var input = $(".search-query");
		var submitSearch = $(".submit-search");
		var regexp = new RegExp(/^[a-zA-Z]+$/);
		this.resultArray = [];
		this.monthNames = [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December"
		];

		this.initiate = function() {
			submitSearch.on("click", function(e) {
				handleSubmit();
			});

			getDataFromApi(_this.resultArray).done(function() {
				if (_this.resultArray.length > 0) {
					$(_this.resultArray).each(function(index, article) {
						$(".post-feed").append(generatedNode(article));
					});
				} else {
					$(".search-results .post-feed").append("<h3>No results</h3>");
				}
			});
		};

		function getInputValue(input) {
			if (!regexp.test($(input).val())) {
				return "";
			}
			return $(input)
				.val()
				.toLowerCase();
		}

		function searchByTitle(arr, element) {
			var hash = window.location.hash.split("#").join("");
			// console.log(element.excerpt);

			// if (element.title.toLowerCase().indexOf(hash) !== -1 && hash !== "") {				
			// 	arr.push(element);
			// }
			if ((element.title.toLowerCase().indexOf(hash) !== -1 || element.excerpt.toLowerCase().indexOf(hash) !== -1) && hash !== "") {				
				arr.push(element);
			}
		}

		function getDataFromApi(array) {
			return $.ajax({
				url: domain + "/ghost/api/v2/content/posts?key=" + apikey + "&include=tags&limit=all",
				type: "GET",
				dataType: "json",
				success: function(response) {
					response;
				},
				error: function(err) {
					console.log(err);
				}
			}).done(function(response) {
				$.each(response.posts, function(i, post) {
					searchByTitle(array, post, getInputValue(input));
				});
				console.log(array)
				return array;
			});
		}

		function handleSubmit() {
			window.location.assign("/search-results/#" + getInputValue(input));
			if (window.location.pathname === "/search-results/") {
				window.location.reload();
			}
		}

		function generatedNode(data) {
			var date = new Date(data.published_at);
			var image = function() {
				if (data.feature_image) {
					return (
						'<a class="post-card-image-link" href="/' +
						data.slug +
						'/">' +
						'<img class="post-card-image" src="' +
						data.feature_image +
						'">' +
						"</a>"
					);
				}
				return ''
			};
			return (
				'<article class="post-card post ">' +
				image() +
				'<div class="post-card-content">' +
				'<header class="post-card-header">' +
				'<a class="post-card-content-link-top" href="/' +
				data.slug +
				'">' +				
				'<h2 class="post-card-title">' +
				data.title + 
				'</h2>' + '</a>' +
				'<div class="post-card-meta-header"' +
				'<span class="post-card-date">' +
				_this.monthNames[date.getMonth()] +
				" " +
				date.getDay() + ", " + date.getFullYear() + 
				"</span></br>" +
				'<span class="post-card-tag-wrap">In' +
				'<b><a class="post-card-tag-link" href="' + data.primary_tag.url + 
				'">' + data.primary_tag.name + '</a></b>' +
				'</span>' +
				"</div>" +
				"</header>" +
				'<a class="post-card-content-link-bottom" href="/' +
				data.slug +
				'">' +
				'<section class="post-card-excerpt">' +
				"<p>" +
				data.excerpt +
				"</p>" +
				"</section></a>" +
				"</div>" +
				"</article>"
			);

		}

		this.initiate();
	}



	$('.burger-menu').click(function() {

		$(this).parents().find('.nav-mobile-menu').toggle(300);
	
	})

	if ($(".search")) {
		var search = new BlogSearch();
		$('.search-query').on('focus', function() {
			$('.search').addClass('is-active');
		})
		$('.search-query').on('blur', function() {
			$('.search').removeClass('is-active');
		})
	}


	$.instagramFeed({
		'username': 'airflyby_blog',
		'container': "#instafeed",
		'display_profile': false,
		'display_biography': false,
		'display_gallery': true,
		'callback': null,
		'styling': true,
		'items': 9,
		'items_per_row': 3,
		'margin': 1 
});
// var moon = new Date();
// var month = moon.getMonth();
if (localStorage.getItem('cookieSeen') != 'shown') {
	$('.cookie-banner').delay(1500).fadeIn();
	$('.accept').click(function() {
		localStorage.setItem('cookieSeen','shown');
		$(this).parents().find('.cookie-banner').fadeOut();
	})
  };
  $('.close').click(function() {
	$('.cookie-banner').fadeOut();
  });



function pagination(c, m) {
    var current = c,
        last = m,
		delta = 2;
		if(c == last || c == 1){
			delta = 3;
		}
        var left = current - delta,
        right = current + delta,
        range = [],
        rangeWithDots = [],
		l;


    for (var i = 1; i <= last; i++) {
        if (i == 1 || i == last || i > left && i < right) {
			range.push(i);
        }
    }

    for (var arr = range, isArray = Array.isArray(arr), i = 0, arr = isArray ? arr : arr[Symbol.iterator]();;) {
        var ref;

        if (isArray) {
            if (i >= arr.length) break;
            ref = arr[i++];
        } else {
            i = arr.next();
            if (i.done) break;
            ref = i.value;
        }

        var n = ref;

        if (l) {
			if (n - l === 2 ) { rangeWithDots.push(l + 1); }
            else if (n - l !== 1) { rangeWithDots.push('...'); }
		}
		// console.log("n= " + n);
		// console.log("l= " + l);
		// console.log("ref= " + ref);
        rangeWithDots.push(n);
		l = n;
    }
	// console.log("n= " + range, l);
	return range;
	
}


function createPagination() {
    var currentPage = parseInt($('.curr-page').text()),
        totalPages = parseInt($('.total-pages').text());
    var url = window.location.href;

    if(totalPages > 1) {
        var paginationArr = pagination(currentPage, totalPages);
        var paginationItem;
        var isCurrent = '';

        for (var i = paginationArr.length - 1; i >= 0; i--) {
        var pageNum = paginationArr[i];

        if (pageNum === currentPage) {
                paginationItem = '<li class="current"><a class="page-nr" >' + pageNum + '</a></li>';
            } else if (typeof pageNum === 'number') {
                var urlArray = url.split('/');
                if(urlArray[urlArray.length - 3] === 'page') {
                    url = url.replace(/\/page\/.*$/,'') + '/';
                }
                paginationItem = '<li>' +
                    '<a href=\"' + url + 'page/' + pageNum + '\" class="page-nr" aria-label=\"Page ' + pageNum + '\">'
                    + pageNum + '</a>' +
                    '</li>';
            } else {
                paginationItem = '<li class=\"ellipsis\">...</li>';
            }
            $('.pagination-previous').after(paginationItem);
        }
    } else {
        $('.pagination').css('display', 'none');
        $('.desktop-pagination').css('display', 'none');
    }
}
createPagination();

$('.desktop-pagination .page-nr ').each(function(){

	var nr = parseInt($(this).text());		
	// console.log(nr);

	var next_nr = parseInt($(this).parent().next().text());
	// console.log("next: " + next_nr);
	if(next_nr - nr >=2){
		$(this).parent().append("<a>...</a>");
	}
	
	// console.log(nr);
});

// var number = parseInt($('.pagination .page-nr ').text());

// console.log(number);

(function ($, undefined) {
    "use strict";

    var $document = $(document);

    $document.ready(function () {

        var $postContent = $(".post-card-content");
        $postContent.fitVids();

        $(".scroll-down").arctic_scroll();

        $(".menu-button, .nav-cover_image, .nav-close").on("click", function(e){
            e.preventDefault();
            $("body").toggleClass("nav-opened nav-closed");
        });

    });

    // Arctic Scroll by Paul Adam Davis
    // https://github.com/PaulAdamDavis/Arctic-Scroll
    $.fn.arctic_scroll = function (options) {

        var defaults = {
            elem: $(this),
            speed: 500
        },

        allOptions = $.extend(defaults, options);

        allOptions.elem.click(function (event) {
            event.preventDefault();
            var $this = $(this),
                $htmlBody = $('html, body'),
                offset = ($this.attr('data-offset')) ? $this.attr('data-offset') : false,
                position = ($this.attr('data-position')) ? $this.attr('data-position') : false,
                toMove;

            if (offset) {
                toMove = parseInt(offset);
                $htmlBody.stop(true, false).animate({scrollTop: ($(this.hash).offset().top + toMove) }, allOptions.speed);
            } else if (position) {
                toMove = parseInt(position);
                $htmlBody.stop(true, false).animate({scrollTop: toMove }, allOptions.speed);
            } else {
                $htmlBody.stop(true, false).animate({scrollTop: ($(this.hash).offset().top) }, allOptions.speed);
            }
        });

    };

    // ==============
    // Ajax Load More
    // ==============

    var pagination_next_url = $('link[rel=next]').attr('href'),
		$load_posts_button  = $('.js-load-posts');

    $load_posts_button.click(function(e) {
        e.preventDefault();

        var request_next_link = pagination_next_url.split(/page/)[0] + 'page/' + pagination_next_page_number + '/';

        $.ajax({
        url: request_next_link,
        beforeSend: function() {
            $load_posts_button.text('Loading');
            $load_posts_button.addClass('button--loading');
        }
        }).done(function(data) {
            var posts = $('.post-card', data);

            $load_posts_button.text('Load More');
            $load_posts_button.removeClass('button--loading');

            $('.post-feed').append(posts);
            // $('#post-feed-mobile').append(posts);

            pagination_next_page_number++;

            // If you are on the last pagination page, add the disabled attribute
            if (pagination_next_page_number > pagination_available_pages_number) {
                $load_posts_button.css('display', "none");
            }
        });
    });
})(jQuery);






});


function searchDelete(x) {
	if (x.matches) { // If media query matches
	  var elem = document.querySelector('.nav-desktop #search');
		elem.parentNode.removeChild(elem);
	}//else{
	// 	var div = document.getElementById('nav-desktop');

	// 	div.innerHTML += '<div class="search" id="search">' +
	// 	'<input class="search-query" type="text" placeholder="Search...">' +
	// 	'<button class="submit-search">' +
	// 	'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
	// 	'<path d="M11 1.99998C15.968 1.99998 20 6.03198 20 11C20 15.968 15.968 20 11 20C6.032 20 2 15.968 2 11C2 6.03198 6.032 1.99998 11 1.99998ZM11 18C14.867 18 18 14.867 18 11C18 7.13198 14.867 3.99998 11 3.99998C7.132 3.99998 4 7.13198 4 11C4 14.867 7.132 18 11 18ZM18.778 18.778C19.1685 18.3875 19.8016 18.3874 20.1921 18.7778L21.6066 20.1919C21.9973 20.5824 21.9971 21.2159 21.6065 21.6065C21.2159 21.9971 20.5824 21.9973 20.1919 21.6066L18.7779 20.1921C18.3875 19.8015 18.3875 19.1685 18.778 18.778Z" fill="#4C5B6D" />' +
	// 	'</svg>' +
	// 	'</button>' +
	//    '</div>';
	// }
  }
  
  var x = window.matchMedia("(max-width: 767px)")
  searchDelete(x) // Call listener function at run time
  x.addListener(searchDelete)
  
  $(window).resize(function(){location.reload(false);});

